import React from 'react'
import { DataTool, type DataToolProps } from '@ztechapps/webui.data-tools'
import { useAdjustmentListContext } from './Context'
import { adjustmentListFieldConfig } from './constants'

export const AdjustmentListDataTool = ({ searchPlaceHolder, ...props }: DataToolProps) => {
  const { adjustmentList, filterCategory } = useAdjustmentListContext()

  return (
    <DataTool
      filterCategory={filterCategory}
      fieldsConfig={adjustmentListFieldConfig}
      onRefresh={adjustmentList?.refetch}
      searchPlaceHolder={searchPlaceHolder ?? 'Search Adjustments'}
      {...adjustmentList}
      {...props}
      onSort={null}
    />
  )
}
